import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <button
          onClick={() => navigate(-1)}
          className="mb-6 flex items-center text-red-600 hover:text-red-700 transition-colors duration-200"
        >
          <FaArrowLeft className="mr-2" />
          <span>Nazad</span>
        </button>

        <h1 className="text-3xl font-bold text-gray-900 mb-8">Politika Privatnosti</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-8 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Prikupljanje Podataka</h2>
            <p className="text-gray-600">
              Zar Mance B2B Portal prikuplja samo neophodne podatke za funkcionisanje B2B platforme, 
              uključujući ime firme, PIB, matični broj, adresu i kontakt informacije.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Korišćenje Podataka</h2>
            <p className="text-gray-600">
              Prikupljeni podaci se koriste isključivo za:
            </p>
            <ul className="list-disc list-inside text-gray-600 mt-2">
              <li>Procesiranje narudžbina</li>
              <li>Komunikaciju sa klijentima</li>
              <li>Unapređenje usluga</li>
              <li>Zakonske obaveze</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Zaštita Podataka</h2>
            <p className="text-gray-600">
              Primenjujemo najsavremenije mere zaštite vaših podataka. Pristup podacima 
              imaju samo ovlašćena lica uz stroge mere kontrole.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Vaša Prava</h2>
            <p className="text-gray-600">
              Imate pravo da:
            </p>
            <ul className="list-disc list-inside text-gray-600 mt-2">
              <li>Zatražite uvid u vaše podatke</li>
              <li>Zatražite izmenu podataka</li>
              <li>Zatražite brisanje podataka</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Kontakt</h2>
            <p className="text-gray-600">
              Za sva pitanja vezana za privatnost podataka, možete nas kontaktirati na:
              <br />
              Email: info@zarmance.rs
              <br />
              Telefon: 063-8702722
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy; 